import { Routes } from '@angular/router';
import { PageLayoutComponent } from './components/organisms/page-layout/page-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PageLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            r => r.DASHBOARD_ROUTES
          ),
      },
      {
        path: 'workflow/:workflowId',
        loadChildren: () =>
          import('./pages/workflow-builder/workflow-builder.routes').then(
            r => r.WORKFLOW_BUILDER_ROUTES
          ),
      },
      {
        path: 'workflow/:workflowId/setup',
        loadChildren: () =>
          import('./pages/workflow-setup/workflow-setup.routes').then(
            r => r.WORKFLOW_SETUP_ROUTES
          ),
      },
    ],
  },
];
